import {Injectable} from '@angular/core';
import {Language} from '../core/entities/entities';
import {HttpService} from '../core/services/http.service';
import {HttpServiceBase} from '../core/services/HttpServiceBase';

@Injectable()
export class LanguageService extends HttpServiceBase<Language> {
  getCleanInstance(): Language {
    return new Language();
  }

  public hasSingleGet(){
    return false;
  }

  public refreshOnRouteChange(){
    return false;
  }

  public fromJson(json): Language {
    const me = this;
    const item: Language = Object.assign(this.getCleanInstance(), json);

    if(json.cardLanguage) {
      item.name = json.cardLanguage || item.name;
      item.code = json.code || '' + item.id;
    }




    return item;
  }

  constructor(protected http: HttpService) {
    super(http);
  }

  getUrl() {
    return  'language';
  }


}



// WEBPACK FOOTER //
// ./src/app/services/language.service.ts